/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkRepublishPaymentNotificationsRequest
 */
export interface BulkRepublishPaymentNotificationsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkRepublishPaymentNotificationsRequest
     */
    paymentReferences: Array<string>;
}

/**
 * Check if a given object implements the BulkRepublishPaymentNotificationsRequest interface.
 */
export function instanceOfBulkRepublishPaymentNotificationsRequest(value: object): value is BulkRepublishPaymentNotificationsRequest {
    if (!('paymentReferences' in value) || value['paymentReferences'] === undefined) return false;
    return true;
}

export function BulkRepublishPaymentNotificationsRequestFromJSON(json: any): BulkRepublishPaymentNotificationsRequest {
    return BulkRepublishPaymentNotificationsRequestFromJSONTyped(json, false);
}

export function BulkRepublishPaymentNotificationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkRepublishPaymentNotificationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentReferences': json['paymentReferences'],
    };
}

export function BulkRepublishPaymentNotificationsRequestToJSON(json: any): BulkRepublishPaymentNotificationsRequest {
    return BulkRepublishPaymentNotificationsRequestToJSONTyped(json, false);
}

export function BulkRepublishPaymentNotificationsRequestToJSONTyped(value?: BulkRepublishPaymentNotificationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentReferences': value['paymentReferences'],
    };
}

